import React, { useContext, useEffect, useState } from "react";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Button from "../UI/Button";
import { OrgIdContext } from "../../store/orgId_context";

const PackageCardNew = ({ pkg, selectedId, onSelect, onCancel, cancelling, onCheckout }) => {
    const {
        ISVCustomer,
        sessionInfo,
        clientType,
        customerRelation,
        aboutOrgId,
      } = useContext(OrgIdContext);
  const isSelected = pkg.Id === sessionInfo?.Extended?.CurrentPackages?.IEI_Package?.PackageId;
  const isCustomPackage = !pkg?.StripePriceId || pkg?.PackageCode?.toUpperCase() === "CUSTOM";
  const [packageJson, setPackageJson] = useState({});

  const cardStyle = {
    border: isSelected ? "3px solid green" : "none",
    boxShadow: "var(--box-shadow-card)",
    borderRadius: "var(--border-radius-card)",
    padding: "1rem",
    color: "var(--main-blue)",
    backgroundColor: "transparent",
    minHeight: "100%",
    display: "flex",
    flexDirection: "column",
    maxWidth: "330px",
    position: "relative",
  };

  useEffect(() => {
    if(!pkg?.PackageDesc) return setPackageJson({});
    try {
        const pkgJson = JSON.parse(pkg.PackageDesc);
        setPackageJson(pkgJson);
    } catch (error) {
        console.error("Error parsing package JSON:", error);
        setPackageJson({});
    }
  }, [pkg]);

  return (
    <Card style={cardStyle}>
      <Typography
        variant="h6"
        style={{
          color: "var(--main-blue)",
          textAlign: "center",
          fontSize: "1rem",
          marginBottom: "10px",
        }}
      >
        {isCustomPackage ? "CUSTOM" : pkg?.PackageCode}
      </Typography>

      {!isCustomPackage && <><Typography
        variant="h2"
        style={{
          color: "var(--main-blue)",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "2.5rem",
          lineHeight: 1,
          margin: "10px 0 5px 0",
        }}
      >
        {pkg?.PricePerMonth}€
      </Typography>

        <Typography
          variant="h6"
          style={{
            color: "var(--main-blue)",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "0.8rem",
            marginBottom: "10px",
          }}
        >
          per month
        </Typography>

      {pkg?.QuantityPerMonth && (
        <Typography
          variant="body2"
          style={{ color: "var(--main-blue)", textAlign: "center" }}
        >
        {pkg?.QuantityPerMonth} invoices / month included {pkg?.PricePerInvoice && ','}
        </Typography>
      )}

      {pkg.PricePerInvoice && (
        <Typography
          variant="body2"
          style={{ color: "var(--main-blue)", textAlign: "center" }}
        >
        then {pkg?.PricePerInvoice}€/invoice
        </Typography>
      )}</>}

      {isCustomPackage && <>
        <Typography
          variant="h2"
          style={{
            color: "var(--main-blue)",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "2rem",
            lineHeight: 1,
            minHeight: "2.5rem",
            margin: "10px 0 5px 0",
          }}
        >
          Let's talk
        </Typography>
        <Typography
          variant="h6"
          style={{
            color: "var(--main-blue)",
            textAlign: "center",
            fontWeight: "bold",
            fontSize: "0.8rem",
            marginBottom: "10px",
          }}
        >
          per month
        </Typography>
        <Typography variant="body2" style={{ color: "var(--main-blue)", textAlign: "center" }}>
          Volume pricing based on your invoice count and needs
        </Typography>
      </>}

      <Typography
        variant="subtitle2"
        style={{
          marginTop: 10,
          minHeight: "2.75rem",
          color: "var(--main-blue)",
          textAlign: "center",
          fontStyle: "italic",
        }}
      >
        <div dangerouslySetInnerHTML={{__html : packageJson?.underTitle || ""}}></div>
      </Typography>

      <div
        style={{
          textAlign: "center",
          marginTop: "20px",
          paddingLeft: "10px",
          paddingRight: "10px",
          flexGrow: 1,
        }}
        dangerouslySetInnerHTML={{__html : packageJson?.body || ""}}
      >
      </div>

      <Typography
        variant="subtitle2"
        style={{
          marginTop: 10,
          marginBottom: 40,
          color: "var(--main-blue)",
          textAlign: "center",
        }}
      >
        <div dangerouslySetInnerHTML={{__html : packageJson?.aboveButton || ""}}></div>
      </Typography>

      <div style={{ textAlign: "center", marginTop: "1rem" }}>
        {!isSelected && (
          <Button
            className="ps-2 pe-2 pt-1 pb-1"
            style={{ width: '100%' }}
            onClick={() => onCheckout(pkg)}
          >
            {isCustomPackage ? 'Contact sales' : 'Choose this package'}
          </Button>
        )}
        {isSelected && (
          <div
            style={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              background: "linear-gradient(135deg, green, #45a049)",
              color: "white",
              padding: "10px 0",
              fontSize: "0.9rem",
              fontWeight: "bold",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
            }}
          >
            ✓ CURRENTLY ACTIVE
            <button
              onClick={onCancel}
              disabled={cancelling}
              style={{
                background: "transparent",
                border: "1px solid rgba(255,255,255,0.7)",
                color: "white",
                borderRadius: "6px",
                padding: "2px 12px",
                fontSize: "0.75rem",
                cursor: cancelling ? "not-allowed" : "pointer",
                opacity: cancelling ? 0.6 : 1,
              }}
            >
              {cancelling ? "Cancelling…" : "Cancel subscription"}
            </button>
          </div>
        )}
      </div>
      <Typography
        variant="subtitle2"
        style={{
          marginTop: 10,
          color: "var(--main-blue)",
          textAlign: "center",
        }}
      >
        <div dangerouslySetInnerHTML={{__html : packageJson?.belowButton || "Cancel anytime"}}></div>
      </Typography>
    </Card>
  );
};

export default PackageCardNew;
